import React from "react";
import { HeartIcon } from "lucide-react";
import { personas } from "../data/landing";
const tones: Record<string, {
  bg: string;
  icon: string;
}> = {
  sage: {
    bg: "bg-sage-light",
    icon: "text-sage-deep"
  },
  azure: {
    bg: "bg-azure-light",
    icon: "text-azure"
  },
  terracotta: {
    bg: "bg-terracotta-light",
    icon: "text-terracotta"
  },
  blush: {
    bg: "bg-blush-light",
    icon: "text-terracotta"
  }
};
export function PersonaSection() {
  return <section className="bg-cream" data-id="element-146" data-mp="10mkikk4zcoof">
      <div className="mx-auto max-w-5xl px-5 py-16 md:py-24" data-id="element-147" data-mp="14ne9znhmslm2">
        <h2 className="text-center font-display text-3xl font-semibold leading-tight text-ink md:text-[2.6rem]" data-id="element-148" data-mp="14ml8p21fyobb">
          Ce Méga Pack est fait pour vous si…
        </h2>

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 md:gap-5" data-id="element-149" data-mp="vln4ojr06gsq">
          {personas.map(p => <li key={p.text} className={`flex gap-4 rounded-3xl px-6 py-7 md:px-8 md:py-9 ${tones[p.tone].bg}`} data-id="element-150" data-mp="3bd2kgb2v2huj">
              <HeartIcon className={`mt-1 h-5 w-5 shrink-0 fill-current ${tones[p.tone].icon}`} aria-hidden="true" data-id="element-151" data-mp="1sl1xh6upr2zh" />
              <p className="font-display text-lg font-medium leading-snug text-ink md:text-xl" data-id="element-152" data-mp="1ol9j2din22m7">
                {p.text}
              </p>
            </li>)}
        </ul>

        <p className="mt-8 text-center text-sm text-ink-soft md:text-base" data-id="element-153" data-mp="1xjd4l9tmize0">
          Une ressource également utile pour les grands-parents et les
          éducateurs chrétiens.
        </p>
      </div>
    </section>;
}